import { FIQAssist } from "../app"
import { Directive, Inject } from "@fiqas/angular-utils";
import { CacheService } from "../services/cache";
@Directive({
    selector: BroadcastSize.selector,
    module: FIQAssist
})
export class BroadcastSize {
    public static selector = "broadcastSize";
    public static SizeEventName = "sizeEventName";
    public static SizeEventWatch = "sizeEventWatch";
    constructor(
        @Inject('$window') private $window: ng.IWindowService,
        @Inject() private cacheService: CacheService
    ) {
    }

    public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes): void {
        var sizeEventName: string = attrs[BroadcastSize.SizeEventName];
        var sizeEventNameArgs: { height: number, width: number } = { height: -1, width: -1 };
        sizeEventNameArgs.height = element[0].offsetHeight;
        sizeEventNameArgs.width = element[0].offsetWidth;
        this.cacheService.setValue(`size:${sizeEventName}`, sizeEventNameArgs);
        var action = differendArgumentsNotUsed => {
            if ((sizeEventNameArgs.height != element[0].offsetHeight || sizeEventNameArgs.width != element[0].offsetWidth) && !!scope && !!scope.$root && !!scope.$root.$broadcast) {
                sizeEventNameArgs.height = element[0].offsetHeight;
                sizeEventNameArgs.width = element[0].offsetWidth;
                scope.$root.$broadcast(`size:${sizeEventName}`, sizeEventNameArgs);
            }
        }
        // WARNING action doesn't use the `newValue`, `oldValue` and `scope` arguments
        scope.$watch<string>(attrs[BroadcastSize.SizeEventWatch], action);
        // WARNING action doesn't use the `window`, `view` arguments
        this.$window.addEventListener('resize', action);
        action(null);
    }
}